const basketSlice = {
  initialState: {
    status: "",
    product: [],

    extra: [],
  },
  reducers: {
    add: (dataSet, action) => {
      return {
        ...dataSet,
        product: [...dataSet.product, action.payload.product],
      };
    },
    delete: (dataSet, action) => {
      return {
        ...dataSet,
        product: [],
      };
    },
    deleteOneProd: (state, action) => {
      const { productId } = action.payload;
      state.product = state.product.filter((prod) => prod._id !== productId);
    },
    decreaseQuantity: (state, action) => {
      const { productId } = action.payload;
      const prod = state.product.find((prod) => prod._id === productId);
      if (prod && prod.quantityInBasket > 1) {
        prod.quantityInBasket -= 1;
      }
    },
    increaseQuantity: (state, action) => {
      const { productId } = action.payload;

      const produ = state.product.find((prod) => prod._id == productId);
      if (produ && produ.quantityInBasket) {
        produ.quantityInBasket += 1;
      }
    },
  },
};

export default basketSlice;
